import { Menu as MenuAntd } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

import Button from '../Buttons';

export const MenuButton = styled(Button)`
  width: 115px;
  height: 36px;
`;

export const Menu = styled(MenuAntd)`
  width: 300px;
  height: 100%;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  background: ${COLOR.GREY_WHITE};
`;

export const ItemGroup = styled(MenuAntd.ItemGroup)`
  margin-top: 20px;
  margin-bottom: 10px;
  .ant-menu-item-group-title {
    font-size: 14px;
    line-height: 18px;
    font-weight: bold;
    text-transform: uppercase;
    padding-left: 40px;
    width: 100%;
    color: ${COLOR.OUTER_SPACE};
  }
  &.bottom-item {
    margin-top: auto;
    margin-bottom: 15px;
  }
`;

export const Item = styled(MenuAntd.Item)`
  &.ant-menu-item {
    color: ${COLOR.OUTER_SPACE};
    box-sizing: border-box;
    margin: 5px 0px;
    height: 50px;
    padding-left: 40px !important;

    &.ant-menu-item-selected {
      background-color: ${COLOR.WHITE};
    }
  }
`;

export const ButtonWrapperItem = styled(Item)`
  &.ant-menu-item {
    margin-top: 0px;
    &:active {
      background-color: transparent;
    }
    &.ant-menu-item-selected {
      background-color: transparent;
      &:after {
        border: none;
      }
    }
  }
`;

export const InsideButtonLink = styled(Link)`
  transition: 0s;
`;

export const Separator = styled.div`
  width: 100%;
  height: 2px;
  background: ${COLOR.ALUMINIUM};
  opacity: 0.14;
`;
